import api from './api';

export function hasCookieConsent(): boolean {
  if (typeof document === 'undefined') return false;
  return document.cookie.match('boat_trader_cookie_consent=accepted') !== null;
}

export function hasAnalyticsConsent(): boolean {
  if (typeof document === 'undefined') return false;
  return document.cookie.match('boat_trader_analytics=accepted') !== null;
}

export function getCookieConsentStatus(): 'accepted' | 'essential' | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match('boat_trader_cookie_consent=(accepted|essential)');
  return match ? match[1] as 'accepted' | 'essential' : null;
}

export async function trackPublicView(itemId: number, itemType: 'boat' | 'motor'): Promise<void> {
  if (!hasCookieConsent()) return;
  
  try {
    await api.post('/tracking/public-view', {
      item_id: itemId,
      item_type: itemType,
      timestamp: new Date().toISOString(),
      url: window.location.href,
    });
  } catch (error) {
    console.warn('[Tracking] Failed to track public view:', error);
  }
}

export async function trackPublicClick(
  itemId: number, 
  itemType: 'boat' | 'motor',
  clickType: 'contact' | 'quote' | 'phone' | 'email' | 'map' | 'share'
): Promise<void> {
  if (!hasCookieConsent()) return;
  
  try {
    await api.post('/tracking/public-click', {
      item_id: itemId,
      item_type: itemType,
      click_type: clickType,
      timestamp: new Date().toISOString(),
      url: window.location.href,
    });
  } catch (error) {
    console.warn('[Tracking] Failed to track public click:', error);
  }
}

export async function trackPublicQuoteRequest(
  itemId: number,
  itemType: 'boat' | 'motor',
  requestData: {
    requester_name: string;
    requester_email: string;
  }
): Promise<void> {
  if (!hasCookieConsent()) return;
  
  try {
    await api.post('/tracking/public-quote-request', {
      item_id: itemId,
      item_type: itemType,
      ...requestData,
      timestamp: new Date().toISOString(),
      url: window.location.href,
    });
  } catch (error) {
    console.warn('[Tracking] Failed to track quote request:', error);
  }
}